export default "__VITE_ASSET__BQXPCZWZ__"